<template>
  <div class="container">
    <div class="large-12 medium-12 small-12 cell">
      <label>
        <input
          type="file"
          id="files"
          ref="files"
          v-on:change="handleFilesUpload($event)"
        />
      </label>
    </div>
    <div v-for="(file, key) in filesBytesActived" :key="key">
      <div class="attachments">
        <div>{{ file.name }}</div>
        <a href="#" @click="Download($event, file)">
          <img :src="attachmentUrl(file)" style="width: 200px; height: 200px" />
        </a>

        <div class="mt-2" v-if="!readonly">
          <a href="#" @click="removeFile($event, file)">
            <label>
              {{ $t("geral.discard") }}
            </label>
          </a>
        </div>
      </div>
    </div>
    <br />
    <b-button v-if="readonly == false" size="sm" class="button" @click="addFiles()">
      <i class="tim-icons icon-attach-87 mb-1 mr-2 ml-0"></i>
      {{ $t("geral.attachmentAdd") }}
    </b-button>
    <br />
    <!-- <div>{{ filesBytesActived }}</div> -->
    <!-- <div>{{ getFilesAsBytes() }}</div> -->
    <!-- <div class="large-12 medium-12 small-12 cell">
      <button v-on:click="submitFiles()">Submit</button>
    </div> -->
    <iframe id="my_iframe" style="display: none"></iframe>
    <!-- <div>{{filesBytes}}</div> -->
    <!-- <div>{{permission}}</div> -->
    <!-- <div>{{readonly}}</div> -->
  </div>
</template>

<script>
export default {
  name: "BaseAttachments",
  props: {
    filesBytes: Array,
    readonly: Boolean,
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    filesBytesActived() {
      console.log('filesBytesActived - begin');
      let active = [];
      if (this.filesBytes) {
        this.filesBytes.forEach(async (file) => {
          if (file.delete == false) {
            active.push(file);
          }
        });
      }
      console.log('filesBytesActived - end');
      return active;
    },
  },
  methods: {
    addFiles() {
      this.$refs.files.click();
    },
    Download(e, file) {
      e.preventDefault();
      this.$api
        .request({
          url: `${this.$store.state.urlTracking}/v1/cargoExpense/attachmentImage/${file.cargoExpenseAttachmentId}`,
          method: "GET",
          responseType: "arraybuffer", //important /////
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `${file.name}${file.extension}`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
    },
    attachmentHref(file) {
      return `${this.$store.state.urlTracking}/v1/cargoExpense/attachmentImage/${file.cargoExpenseAttachmentId}`; // file.content;
    },

    attachmentUrl(file) {
      if (file.fileType.indexOf("image") >= 0) {
        return file.content;
      }
      if (file.fileType.indexOf("application/pdf") >= 0) {
        return "/img/attachments/pdf-icon.png";
      }
      if (file.fileType.indexOf("document") >= 0) {
        return "/img/attachments/word-icon.png";
      }
      return "/img/attachments/word-icon.png";
    },

    getFilesAsBytes() {
      console.log("fileBytes")
      console.log(this.filesBytes)
      return this.filesBytes;
      /*
        Iteate over any file sent over appending the files
        to the form data.
      */
      // let formData = [];
      // for (var i = 0; i < this.files.length; i++) {
      //   let file = this.files[i];
      //   formData.push({
      //     name: this.files[i].name,
      //     content: file,
      //   });
      // }

      // return formData;
    },

    getFilesAsForm() {
      /*
        Iteate over any file sent over appending the files
        to the form data.
      */
      let formData = new FormData();

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }

      return formData;
    },

    submitFiles() {
      let formData = new FormData();

      /*
          Iteate over any file sent over appending the files
          to the form data.
        */
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }

      /*
          Make the request to the POST /select-files URL
        */
      axios
        .post("/select-files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function () {
          console.log("SUCCESS!!");
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload(event) {
      //console.log("handleFilesUpload");
      // let uploadedFiles = this.$refs.files.files;

      // /*
      //     Adds the uploaded file to the files array
      //   */
      // for (var i = 0; i < uploadedFiles.length; i++) {
      //   this.files.push(uploadedFiles[i]);
      // }
      console.log('handleFilesUpload do demonio');

      const fileElement = event.target;
      const file = fileElement.files[0];
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          //   this.fileName = file.name;
          this.files.push(reader.result);

          this.filesBytes.push({
            delete: false,
            fileType: file.type,
            name: file.name,
            content: reader.result,
          });
          // console.log(reader.result);
          this.$emit("change", reader.result);
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    // removeFile(e, key) {
    //   this.files.splice(key, 1);
    //   this.$emit("remove", key);
    //   e.preventDefault();
    // },

    /*
        Removes a select file the user has uploaded
      */
    removeFile(e, attachment) {
      e.preventDefault();
      console.log('removeFile');
      if (this.filesBytes) {
        this.filesBytes.forEach(async (file) => {
          if (attachment == file) {
            file.delete = true;
          }
        });
      }
      this.$emit("remove", key);
    },
  },
};
</script>

<style scoped>
.attachments {
  border: 1px;
  border-color: #2b3553;
  border-radius: 0.4285rem;
  border-style: solid;
  margin-bottom: 10px;
  padding: 10px;
  text-align: center;
}

input[type="file"] {
  position: absolute;
  top: -500px;
}

div.file-listing {
  width: 200px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}
</style>